export const TERMS_MODAL_TITLE = "Điều khoản Dịch vụ";

export const TERMS_CONTENT = [
  {
    type: "p",
    text: "Chào mừng bạn, các Điều khoản Dịch vụ này điều chỉnh việc bạn truy cập, đăng ký tài khoản và sử dụng trò chơi, website, ứng dụng và các dịch vụ liên quan do [Tên công ty/cá nhân] vận hành.",
  },
  {
    type: "p",
    text: "Bằng việc đăng ký tài khoản, truy cập hoặc sử dụng Dịch vụ, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý với các Điều khoản này. Nếu bạn không đồng ý, vui lòng không sử dụng Dịch vụ.",
  },
  { type: "title", text: "1. Phiên bản thử nghiệm" },
  {
    type: "p",
    text: "Dịch vụ hiện có thể đang được cung cấp dưới dạng thử nghiệm, beta, alpha hoặc phát hành sớm.",
  },
  { type: "title", text: "2. Tài khoản người dùng" },
  {
    type: "p",
    text: "Bạn đồng ý cung cấp thông tin đăng ký chính xác, đầy đủ và cập nhật. Bạn chịu trách nhiệm bảo mật tài khoản, mật khẩu và mọi hoạt động phát sinh từ tài khoản của mình.",
  },
  { type: "title", text: "3. Độ tuổi sử dụng" },
  {
    type: "p",
    text: "Bạn cam kết rằng mình đủ tuổi theo quy định pháp luật để sử dụng Dịch vụ, hoặc đã có sự đồng ý của cha mẹ/người giám hộ hợp pháp nếu chưa đủ tuổi thành niên.",
  },
  { type: "title", text: "4. Hành vi bị cấm" },
  { type: "p", text: "Bạn không được:" },
  {
    type: "ul",
    items: [
      "sử dụng Dịch vụ cho mục đích trái pháp luật;",
      "gian lận, khai thác lỗi, dùng bot hoặc phần mềm can thiệp;",
      "tấn công, gây rối hoặc làm gián đoạn hệ thống;",
      "mua bán, chuyển nhượng tài khoản trái phép;",
      "đăng tải nội dung vi phạm pháp luật hoặc xâm phạm quyền của bên thứ ba.",
    ],
  },
  { type: "title", text: "5. Nội dung người dùng" },
  {
    type: "p",
    text: "Bạn chịu trách nhiệm đối với mọi nội dung mình đăng tải hoặc cung cấp thông qua Dịch vụ. Bạn cam kết có đầy đủ quyền hợp pháp đối với nội dung đó. Bạn cấp cho chúng tôi quyền sử dụng nội dung này trong phạm vi cần thiết để vận hành, cải thiện và quảng bá Dịch vụ.",
  },
  { type: "title", text: "6. Quyền sở hữu" },
  {
    type: "p",
    text: "Mọi quyền sở hữu trí tuệ đối với Dịch vụ và các thành phần liên quan thuộc về chúng tôi hoặc bên cấp phép. Bạn chỉ được quyền sử dụng Dịch vụ theo phạm vi mà Điều khoản này cho phép.",
  },
  { type: "title", text: "7. Quyền riêng tư" },
  {
    type: "p",
    text: "Việc thu thập và xử lý dữ liệu cá nhân của bạn được thực hiện theo Chính sách Quyền riêng tư của chúng tôi. Bằng việc sử dụng Dịch vụ, bạn đồng ý với việc xử lý dữ liệu đó theo chính sách áp dụng.",
  },
  { type: "title", text: "8. Tạm ngừng hoặc chấm dứt" },
  {
    type: "p",
    text: "Chúng tôi có quyền tạm ngừng, hạn chế hoặc chấm dứt quyền truy cập của bạn vào Dịch vụ bất kỳ lúc nào nếu phát hiện vi phạm Điều khoản, hành vi gian lận, rủi ro bảo mật hoặc vì nhu cầu vận hành.",
  },
  { type: "title", text: "9. Miễn trừ và giới hạn trách nhiệm" },
  {
    type: "p",
    text: "Dịch vụ được cung cấp trên cơ sở “nguyên trạng” và “sẵn có”. Trong phạm vi pháp luật cho phép, chúng tôi không bảo đảm Dịch vụ sẽ không có lỗi, không bị gián đoạn hoặc đáp ứng đầy đủ mọi kỳ vọng của bạn. Chúng tôi không chịu trách nhiệm đối với mất dữ liệu, mất tiến trình chơi hoặc các thiệt hại gián tiếp phát sinh từ việc sử dụng Dịch vụ.",
  },
  { type: "title", text: "10. Thay đổi điều khoản" },
  {
    type: "p",
    text: "Chúng tôi có thể cập nhật Điều khoản này theo từng thời điểm. Phiên bản cập nhật sẽ có hiệu lực kể từ khi được công bố trên website, ứng dụng hoặc kênh chính thức của chúng tôi.",
  },
  { type: "title", text: "11. Luật áp dụng" },
  {
    type: "p",
    text: "Điều khoản này được điều chỉnh theo pháp luật của [quốc gia/vùng lãnh thổ áp dụng]. Mọi tranh chấp sẽ được giải quyết tại [tòa án/trọng tài có thẩm quyền], trừ khi pháp luật bắt buộc có quy định khác.",
  },
  {
    type: "p",
    text: "Bằng việc nhấn “Đăng ký” hoặc sử dụng Dịch vụ, bạn xác nhận đã đọc và đồng ý với Điều khoản này.",
  },
];
